export default "__VITE_ASSET__071a865b__"